import { Registry } from '@vscode-alt/monaco-editor/esm/vs/platform/registry/common/platform';
import { IWorkbenchContributionsRegistry, LifecyclePhase, IWorkbenchContribution, ILifecycleService } from '@workbench-stack/core';
import { IInstantiationService, IConstructorSignature0, ServicesAccessor } from '@vscode-alt/monaco-editor/esm/vs/platform/instantiation/common/instantiation';
import { Extensions } from '../constants';

class WorkbenchContributionsRegistry implements IWorkbenchContributionsRegistry {

    private instantiationService: IInstantiationService | undefined;
    private lifecycleService: ILifecycleService | undefined;

    private readonly toBeInstantiated = new Map<LifecyclePhase, IConstructorSignature0<IWorkbenchContribution>[]>();

    public registerWorkbenchContribution(ctor: IConstructorSignature0<IWorkbenchContribution>, phase: LifecyclePhase = LifecyclePhase.Starting): void {

    }

    public start(accessor: ServicesAccessor): void {

    }
}

Registry.add(Extensions.Workbench, new WorkbenchContributionsRegistry());
